import { Col, Row, Select } from "antd";
import { useEffect, useState } from "react";

export function TagSelector({ value = [], onChange, allowClear = false }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch("/api/tags/list/")
      .then((r) => r.json())
      .then((data) => {
        setOptions(
          data.map((t) => ({
            label: t.name,
            value: t.id,
          }))
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Row style={{ marginBottom: 16 }}>
        <Col span={4}>
            Tags
        </Col>
        <Col span={20}>
          <Select
            mode="multiple"
            allowClear={allowClear}
            style={{ width: "100%" }}
            placeholder="Select tags"
            value={value}
            options={options}
            loading={loading}
            onChange={onChange}
          />
      </Col>
    </Row>
  );
}

export function SubjectSelector({ value, onChange, allowClear = false, isOverride=false }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch("/api/subjects/list/")
      .then((r) => r.json())
      .then((data) =>
        setOptions(
          data.map((s) => ({
            label: s.name,
            value: s.id,
          }))
        )
      );
  }, []);

  return (
    <Row style={{ marginBottom: 16 }}>
      <Col span={4} style={ isOverride ? { color: '#fa0', fontWeight: 'bold' } : {} }>
        Subject
      </Col>
      <Col span={20}>
      <Select
        allowClear={allowClear}
        style={isOverride ? 
            { 
                borderRadius: '8px', 
                border: '2px solid #fa0', 
                width: "100%" 
            } : {
                width: "100%" 
            }
        }
        placeholder="Select subject"
        value={value}
        options={options}
        onChange={onChange}
      />
      </Col>
    </Row>
  );
}
export function LocationSelector({ value, onChange, allowClear = false }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch("/api/locations/list/")
      .then((r) => r.json())
      .then((data) =>
        setOptions(
          data.map((l) => ({
            label: l.name,
            value: l.id,
          }))
        )
      );
  }, []);

  return (
    <Row style={{ marginBottom: 16 }}>
        <Col span={4}>
            Location
        </Col>
        <Col span={20}>
      <Select
        allowClear={allowClear}
        style={{ width: "100%" }}
        placeholder="Select location"
        value={value}
        options={options}
        onChange={onChange}
      />
        </Col>
    </Row>
  );
}

export function GallerySelector({ value = [], onChange, allowClear = false }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch("/api/galleries/list/")
      .then((r) => r.json())
      .then((data) =>
        setOptions(
          data.map((g) => ({
            label: g.name,
            value: g.id,
          }))
        )
      );
  }, []);

  return (
    <Row style={{ marginBottom: 16 }}>
        <Col span={4}>
            Galleries
        </Col>
        <Col span={20}>
      <Select
        mode="multiple"
        allowClear={allowClear}
        style={{ width: "100%" }}
        placeholder="Select galleries"
        value={value}
        options={options}
        onChange={onChange}
      />
        </Col>
    </Row>
  );
}
